/**
 * Created by andrey on 24.02.2021.
 */

const MergeTutorials = {
    dwarf_hustlemerge: {
        steps: [
            {
                type: Map2d.CLICK_UNIT,
                targets: { code: "dwarf", stage: 1 },
                arrowDelay: 2,
                highlight: false
            },
            {
                type: Map2d.CLICK_UNIT,
                targets: { code: "dwarf", stage: 1 },
                arrowDelay: 2,
                highlight: false
            },
            {
                type: Map2d.CLICK_UNIT,
                targets: { code: "dwarf", stage: 1 },
                arrowDelay: 2,
                highlight: false
            },
            {
                type: Map2d.CLICK_UNIT,
                targets: { code: "dwarf", stage: 1 },
                arrowDelay: 2,
                highlight: false
            }
        ]
    },

    story_fog_fog4_0: {
        steps: [
            {
                type: Map2d.MERGE,
                targets: { code: "wood", stage: 0 },
                minUnits: 5,
                region: "fog4_0",
                person: "dwarf",
                text: ["Tutorial.merge5.step1.1", { code: "wood", stage: 0 }, "Tutorial.merge5.step1.2", { code: "wood", stage: 1 }]
            }
        ]
    },

    woodgenerator_1: {
        filter: function () {
            if (Map2d.currentMap.workers.findFree() === undefined) {
                return false;
            }

            const unitData = Families.woodgenerator.units[0];
            const energy = unitData.mineable.tasks[0].energy;

            return cleverapps.lives.canTake(energy);
        },
        steps: [
            {
                type: Map2d.START_MINING,
                targets: { code: "woodgenerator", stage: 0 },
                person: "narrator",
                text: "Tutorial.woodgenerator_1.step1"
            },
            {
                type: Map2d.SPAWN,
                targets: { code: "woodgenerator", stage: 0 },
                person: "narrator",
                wait: "15 seconds",
                text: "Tutorial.woodgenerator_1.step2"
            }
        ]
    },

    story_kraken_0: {
        filter: function () {
            const region = Map2d.currentMap.regions.monsters;
            for (let i = 0; i < region.positions.length; i++) {
                const monster = Map2d.currentMap.getUnit(region.positions[i].x, region.positions[i].y);
                if (monster && monster.getData().monster === "kraken") {
                    const info = monster.getActionInfo();
                    if (info && info.buttons.wands.wands <= Map2dLocation.currentLocation.wands) {
                        return true;
                    }
                }
            }
        },
        steps: [
            {
                type: Map2d.START_MINING,
                keepAdditionalViews: true,
                controls: ["KrakenFeastMissionIcon"],
                monster: "kraken",
                targets: [{ code: "kraken", stage: 0 }],
                person: "dwarf",
                text: "Tutorial.kraken_0.step1"
            },
            {
                type: Map2d.SPAWN,
                keepAdditionalViews: true,
                controls: ["KrakenFeastMissionIcon"],
                monster: "kraken",
                targets: [{ code: "kraken", stage: 0 }],
                prizes: { code: "coins", stage: 0 },
                wait: "15 seconds"
            }
        ]
    },

    crystal_use: {
        steps: [
            {
                type: Map2d.MERGE,
                targets: { code: "crystal", stage: 2 },
                person: "dwarf",
                text: ["Tutorial.crystal.step1.1", { code: "crystal", stage: 2 }, "Tutorial.crystal.step1.2", { code: "crystal", stage: 3 }]
            },
            {
                type: Map2d.MERGE,
                targets: [{ code: "crystal", stage: 3 }, { code: "woodchest", stage: 1 }],
                person: "dwarf",
                text: ["Tutorial.crystal.step2.1", { code: "crystal", stage: 3 }, "Tutorial.crystal.step2.2", { code: "woodchest", stage: 1 }, "Tutorial.crystal.step2.3", { code: "woodchest", stage: 2 }]
            }
        ]
    },

    salepass: {
        steps: [
            {
                type: Map2d.FORCE,
                targets: { code: "discountshop", stage: 0 },
                person: "dwarf",
                force: Forces.SALEPASS_FORCE,
                text: "Tutorial.salepass.step1"
            }, {
                type: Map2d.CLOSE_WINDOWS
            }
        ]
    },

    undersea2: {
        steps: [{
            type: Map2d.MERGE,
            targets: { code: "sea2lisa", stage: 0 },
            person: "king",
            text: "Tutorial.undersea2.step1"
        },
        {
            type: Map2d.MERGE,
            targets: { code: "seastrawberry", stage: 0 },
            person: "dwarf",
            text: "Tutorial.undersea2.step2"
        },
        {
            type: Map2d.MERGE,
            targets: { code: "seastrawberry", stage: 1 }
        },
        {
            type: Map2d.MERGE,
            targets: { code: "seastrawberry", stage: 2 }
        },
        {
            type: Map2d.SPAWN,
            targets: { code: "seastrawberry", stage: 3 },
            person: "dwarf",
            text: "Tutorial.undersea2.step3"
        },
        {
            type: Map2d.FEED_HERO,
            targets: { code: "seastrawberry", stage: 4 },
            person: "king",
            text: "Tutorial.undersea2.step4",
            arrowDelay: 0.5,
            fingerDelay: 0.1
        },
        {
            type: Map2d.OPENFOG,
            targets: "fog1",
            wait: "10 seconds",
            person: "king",
            controls: ["MenuBarWandsItem"],
            text: "Tutorial.undersea2.step5"
        }]
    },

    undersea3: {
        steps: [{
            type: Map2d.MERGE,
            targets: { code: "sea2lisa", stage: 0 },
            person: "king",
            text: "Tutorial.undersea2.step1"
        },
        {
            type: Map2d.MERGE,
            targets: { code: "seastrawberry", stage: 0 },
            person: "dwarf",
            text: "Tutorial.undersea2.step2"
        },
        {
            type: Map2d.MERGE,
            targets: { code: "seastrawberry", stage: 1 }
        },
        {
            type: Map2d.MERGE,
            targets: { code: "seastrawberry", stage: 2 }
        },
        {
            type: Map2d.SPAWN,
            targets: { code: "seastrawberry", stage: 3 },
            person: "dwarf",
            text: "Tutorial.undersea2.step3"
        },
        {
            type: Map2d.FEED_HERO,
            targets: { code: "seastrawberry", stage: 4 },
            person: "king",
            text: "Tutorial.undersea2.step4",
            arrowDelay: 0.5,
            fingerDelay: 0.1
        },
        {
            type: Map2d.OPENFOG,
            targets: "fog1",
            wait: "10 seconds",
            person: "king",
            controls: ["MenuBarWandsItem"],
            text: "Tutorial.undersea2.step5"
        }]
    },

    dragonia2: {
        steps: [{
            type: Map2d.MERGE,
            targets: { code: "dr2dragonblue", stage: 0 },
            person: "dwarf",
            text: "Tutorial.dragonia2.step1"
        },
        {
            type: Map2d.MERGE,
            targets: { code: "drfruit", stage: 0 },
            person: "dwarf",
            text: "Tutorial.dragonia2.step2"
        },
        {
            type: Map2d.MERGE,
            targets: { code: "drfruit", stage: 1 }
        },
        {
            type: Map2d.MERGE,
            targets: { code: "drfruit", stage: 2 }
        },
        {
            type: Map2d.SPAWN,
            targets: { code: "drfruit", stage: 3 },
            person: "dwarf",
            text: "Tutorial.dragonia2.step3"
        },
        {
            type: Map2d.FEED_HERO,
            targets: { code: "drfruit", stage: 4 },
            person: "dwarf",
            text: "Tutorial.dragonia2.step4",
            arrowDelay: 0.5,
            fingerDelay: 0.1
        },
        {
            type: Map2d.OPENFOG,
            targets: "fog1",
            wait: "10 seconds",
            person: "dwarf",
            controls: ["MenuBarWandsItem"],
            text: "Tutorial.dragonia2.step5"
        }]
    },

    story_dr2field_0: {
        steps: [
            {
                type: Map2d.FIELD_HARVEST,
                allMoves: true,
                targets: { code: "dr2field", stage: 0 },
                action: { type: FieldInfoView.ACTION_HARVEST },
                person: "dwarf",
                text: "Tutorial.dr2field.step1"
            },
            {
                type: Map2d.FIELD_PLANT,
                allMoves: true,
                targets: { code: "dr2field", stage: 0 },
                action: { type: FieldInfoView.ACTION_PLANT },
                person: "dwarf",
                text: "Tutorial.dr2field.step2"
            }
        ]
    },

    story_drproducer0a_0: {
        steps: [
            {
                type: Map2d.FIELD_HARVEST,
                allMoves: true,
                targets: { code: "drproducer0a", stage: 0 },
                action: { type: FieldInfoView.ACTION_HARVEST },
                person: "dwarf",
                text: "Tutorial.drproducer0a.step1"
            },
            {
                type: Map2d.FIELD_PLANT,
                allMoves: true,
                targets: { code: "drproducer0a", stage: 0 },
                action: { type: FieldInfoView.ACTION_PLANT },
                person: "dwarf",
                text: "Tutorial.drproducer0a.step2"
            }
        ]
    },

    rapunzel_dollsource: {
        steps: [
            {
                type: Map2d.START_MINING,
                targets: { code: "rpdollsource", stage: 0, mined: 0 },
                text: "Tutorial.rapunzel.step1"
            },
            {
                type: Map2d.SPAWN,
                targets: { code: "rpdollsource", stage: 0 },
                text: "Tutorial.rapunzel.step2",
                wait: "10 seconds"
            }
        ]
    },

    rapunzel_customer: {
        filter: function () {
            const unit = Map2d.currentMap.listAvailableUnits({ code: "rpprince", stage: 0 })[0];
            const recipe = unit.findComponent(Customer).getCurrentRecipe();
            return recipe && recipe.isEnoughIngredients();
        },
        steps: [
            {
                type: Map2d.CLICK_UNIT,
                targets: { code: "rpprince", stage: 0 },
                text: "Tutorial.rapunzel.step3",
                waitAfter: 1700
            },
            {
                type: Map2d.EXCHANGE,
                targets: { code: "rpprince", stage: 0 }
            }
        ]
    },

    rapunzel2_doll: {
        steps: [
            {
                type: Map2d.START_MINING,
                targets: { code: "rpdollsource", stage: 0, mined: 0 },
                region: "tutor_rp2_1",
                text: "Tutorial.rapunzel2.step1"
            },
            {
                type: Map2d.SPAWN,
                targets: { code: "rpdollsource", stage: 0 },
                text: "Tutorial.rapunzel2.step2",
                wait: "10 seconds"
            },
            {
                type: Map2d.START_MINING,
                targets: { code: "rpdollsource", stage: 0, mined: 0 },
                region: "tutor_rp2_2",
                text: "Tutorial.rapunzel2.step3"
            },
            {
                type: Map2d.SPAWN,
                targets: { code: "rpdollsource", stage: 0 },
                text: "Tutorial.rapunzel2.step4",
                wait: "10 seconds"
            },
            {
                type: Map2d.MERGE,
                targets: { code: "rprapuncust", stage: 0 },
                person: "dwarf",
                wait: "6 seconds",
                text: "Tutorial.rapunzel2.step5"
            }
        ]
    },

    rapunzel3: {
        steps: [
            {
                type: Map2d.START_MINING,
                targets: { code: "rpplatesource", stage: 0, mined: 0 },
                text: "Tutorial.rapunzel3.step1"
            },
            {
                type: Map2d.SPAWN,
                targets: { code: "rpplatesource", stage: 0 },
                text: "Tutorial.rapunzel3.step2",
                waitAfter: 800,
                wait: "10 seconds"
            },
            {
                type: Map2d.MERGE,
                targets: { code: "rpplate", stage: 0 },
                person: "dwarf",
                wait: "6 seconds",
                text: "Tutorial.rapunzel3.step3"
            }
        ]
    },

    treasureisland_0: {
        steps: [
            {
                type: Map2d.CLICK_UNIT,
                targets: { code: "dr2treasuremap", stage: 0 },
                text: "Tutorial.treasuremap.step1",
                waitAfter: 2500
            }
        ]
    },

    easter_eggssource: {
        steps: [
            {
                type: Map2d.START_MINING,
                targets: { code: "eaeggssource", stage: 0 },
                text: "Tutorial.easter.step1"
            },
            {
                type: Map2d.SPAWN,
                targets: { code: "eaeggssource", stage: 0 },
                wait: "10 seconds"
            }
        ]
    },

    easter_eggssource1: {
        steps: [
            {
                type: Map2d.MERGE,
                targets: { code: "eaeggs", stage: 0 },
                text: "Tutorial.eastereggssource.step1"

            },
            {
                type: Map2d.START_MINING,
                targets: { code: "eaeggssource", stage: 0 },
                region: "tutor_es_1",
                text: "Tutorial.eastereggssource.step2"
            },
            {
                type: Map2d.SPAWN,
                targets: { code: "eaeggssource", stage: 0 },
                wait: "4 seconds"
            }
        ]
    },

    story_eaeggs_3: {
        steps: [
            {
                type: Map2d.CLICK_UNIT,
                targets: { code: "eaprince", stage: 0 },
                text: "Tutorial.eastereggs.step1"
            },
            {
                type: Map2d.EXCHANGE,
                targets: { code: "eaprince", stage: 0 }
            },
            {
                type: Map2d.SPAWN,
                targets: { code: "eabaskets", stage: 0 }
            }
        ]
    },

    collections: {
        steps: [{
            type: Map2d.MERGE,
            targets: { code: "clhydra", stage: 0 },
            person: "keeper",
            text: "Tutorial.collections.step1"
        },
        {
            type: Map2d.MERGE,
            targets: { code: "clhydra", stage: 1 },
            person: "keeper",
            text: "Tutorial.collections.step2"
        }]
    },

    story_clhydra_2: {
        steps: [{
            type: Map2d.OPENCHEST,
            person: "keeper",
            targets: { code: "clsimplechest", stage: 0 },
            text: "Tutorial.story_clhydra_2.step1"
        }]
    },

    story_clstrawberry_3: {
        steps: [{
            type: Map2d.SPAWN,
            person: "keeper",
            targets: { code: "clstrawberry", stage: 3 },
            text: "Tutorial.story_clstrawberry_3.step1"
        },
        {
            type: Map2d.FEED_HERO,
            person: "keeper",
            targets: { code: "clstrawberry", stage: 4 },
            controls: ["PawBoxIcon"],
            text: "Tutorial.story_clstrawberry_3.step2",
            arrowDelay: 0.5,
            fingerDelay: 0.1
        }]
    },

    story_clpawchest_0: {
        steps: [{
            type: Map2d.OPENCHEST,
            person: "keeper",
            targets: { code: "clpawchest", stage: 0 },
            text: "Tutorial.story_clpawchest_0.step1"
        }]
    },

    story_clshop_0: {
        steps: [{
            type: Map2d.BUY_FREE_UNIT,
            person: "keeper",
            targets: { code: "clshop", stage: 0 },
            text: "Tutorial.story_clshop_0.step1"
        }]
    },

    free_worker: {
        steps: [{
            type: Map2d.START_BUILDING,
            person: "worker",
            text: "Tutorial.free_worker.step1"
        }]
    },

    advshrub_1: {
        steps: [{
            type: Map2d.START_MINING,
            targets: { code: "advshrub", stage: 1, mined: 0 },
            text: "Tutorial.advshrub_1.step1",
            arrowDelay: 3
        }, {
            type: Map2d.HARVEST,
            targets: { code: "advshrub", stage: 1 },
            wait: "15 seconds"
        }, {
            type: Map2d.START_MINING,
            targets: { code: "advshrub", stage: 1, mined: 1 },
            text: "Tutorial.advshrub_1.step2",
            wait: "15 seconds",
            arrowDelay: 1
        }, {
            type: Map2d.HARVEST,
            targets: { code: "advshrub", stage: 1 },
            wait: "15 seconds"
        }, {
            type: Map2d.START_MINING,
            targets: { code: "advshrub", stage: 1, mined: 0 },
            text: "Tutorial.advshrub_1.step3",
            wait: "15 seconds",
            arrowDelay: 3
        }, {
            type: Map2d.HARVEST,
            targets: { code: "advshrub", stage: 1 },
            wait: "15 seconds"
        }, {
            type: Map2d.START_MINING,
            targets: { code: "advshrub", stage: 1, mined: 1 },
            text: "Tutorial.advshrub_1.step4",
            wait: "15 seconds",
            arrowDelay: 1
        }, {
            type: Map2d.HARVEST,
            targets: { code: "advshrub", stage: 1 },
            wait: "15 seconds"
        }, {
            type: Map2d.FORCE,
            force: Forces.STORAGE_FORCE,
            text: "Tutorial.advshrub_1.step5",
            person: "worker"
        }, {
            type: Map2d.CLOSE_WINDOWS,
            text: "Tutorial.advshrub_1.step6",
            person: "worker",
            dialogueDuration: 6000
        }]
    }
};

MergeTutorials.dragonia3 = cleverapps.clone(MergeTutorials.dragonia2, true);

Object.keys(MergeTutorials).forEach((id) => {
    MergeTutorials[id].id = id;
});
